import script from "./ClaimTable.vue?vue&type=script&setup=true&lang=ts"
export * from "./ClaimTable.vue?vue&type=script&setup=true&lang=ts"

const __exports__ = script;

export default __exports__